import { ReactNode } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
} from '@chakra-ui/react';
import { KText } from '../../text';

type ModalWrapperProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: any;
  children: ReactNode;
  footer?: ReactNode | false;
  size?: string;
  closeOnOverlayClick?: boolean;
  ctaAction?: any;
  ctaLabel?: string;
  isCtaLoading?: boolean;
  loadingText?: string;
  ctaButtonProps?: React.ComponentProps<typeof Button>;
  enableSecondaryCTA?: boolean;
  modalContentProps?: React.ComponentProps<typeof ModalContent>;
  modalHeaderProps?: React.ComponentProps<typeof ModalHeader>;
  subHeaderTextProps?: any;
  titleProps?: any;
  modalBodyProps?: React.ComponentProps<typeof ModalBody>;
  subHeaderText?: string;
  enableCancelBtn?: boolean;
  modalFooterProps?: React.ComponentProps<typeof ModalFooter>;
  hideCloseButton?: boolean;
  closeOnEsc?: boolean;
  modalOverlayProps?: React.ComponentProps<typeof ModalOverlay>;
  modalCloseButtonProps?: React.ComponentProps<typeof ModalCloseButton>;
};

export const KModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer = true,
  size = 'md',
  closeOnOverlayClick = true,
  ctaAction,
  ctaLabel = 'Save',
  isCtaLoading = false,
  ctaButtonProps = {},
  modalContentProps = {},
  modalBodyProps = {},
  modalHeaderProps = {},
  subHeaderText = '',
  subHeaderTextProps = {},
  enableCancelBtn = true,
  modalFooterProps = {},
  titleProps = {},
  hideCloseButton = false,
  closeOnEsc = true,
  modalOverlayProps = {},
  modalCloseButtonProps = {},
  ...props
}: ModalWrapperProps) => {
  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size={size}
      isCentered
      closeOnOverlayClick={closeOnOverlayClick}
      closeOnEsc={closeOnEsc}
      {...props}
    >
      <ModalOverlay {...modalOverlayProps} />
      <ModalContent {...modalContentProps}>
        <ModalHeader py="12px" {...modalHeaderProps}>
          <KText size="md-medium" color="secondary-900" {...titleProps}>
            {title}
          </KText>
          {subHeaderText && (
            <KText size="sm-medium" mt="xs" {...subHeaderTextProps}>
              {subHeaderText}
            </KText>
          )}
        </ModalHeader>
        {!hideCloseButton && (
          <ModalCloseButton
            bg="transparent"
            _hover={{}}
            {...modalCloseButtonProps}
          />
        )}

        <ModalBody pt={0} {...modalBodyProps}>
          {children}
        </ModalBody>
        {footer === true ? (
          <ModalFooter pt="0" gap="6px" {...modalFooterProps}>
            {enableCancelBtn && (
              <Button variant="secondary" onClick={onClose}>
                Cancel
              </Button>
            )}
            <Button
              isLoading={isCtaLoading}
              loadingText="Updating"
              variant="primary"
              onClick={ctaAction}
              {...ctaButtonProps}
            >
              {ctaLabel}
            </Button>
          </ModalFooter>
        ) : footer ? (
          <ModalFooter p={0} display="flex" justifyContent="center">
            {footer}
          </ModalFooter>
        ) : null}
      </ModalContent>
    </Modal>
  );
};
